"use client";

import { c as _c } from "react/compiler-runtime";
import { WhopAuthCard } from "./whop-auth-card";
interface LoginFormProps {
  redirect?: string | null;
}
export function LoginForm(t0) {
  const $ = _c(2);
  const {
    redirect
  } = t0;
  let t1;
  if ($[0] !== redirect) {
    t1 = <WhopAuthCard initialMode="in" redirect={redirect} data-sentry-element="WhopAuthCard" data-sentry-component="LoginForm" data-sentry-source-file="login-form.tsx" />;
    $[0] = redirect;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}